import React, { useEffect, useState } from 'react';
import { istSichtbar } from './bedingung';
import api from './axiosSetup';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import CustomNavbar from './CustomNavbar';
import cfg from '../config';

const SrvApplyHaes = () => {
  const [formData, setFormData]     = useState({});
  const [formTitle, setFormTitle]   = useState('');
  const [formFields, setFormFields] = useState([]);
  const [typeFields, setTypeFields] = useState({});
  const [loading, setLoading]       = useState(true);
  const [errors, setErrors]         = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/api/form/SrvApplyHaes.jsx')
      .then(response => {
        setFormTitle(response.data.title || '');
        setFormFields(response.data.fields || []);
        setTypeFields(response.data.typeFields || {});
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Ein Feld vom Typ costume-type-select IST die Typauswahl - dafuer gibt es
  // den Typ. Bei einem gewoehnlichen Auswahlfeld wird weiterhin geraten,
  // indem die Optionen gegen die typabhaengigen Zusatzfelder geprueft werden.
  //
  // Vorher hing beides an typeFields. Das ist leer, seit die Typabhaengigkeit
  // ueber showIf laeuft - damit galt die Typauswahl als gewoehnliches Feld und
  // handleTypeChange lief nie. Folge: wer Saubachhexe waehlte, die
  // Schuhgroesse eintrug und dann auf Weckafresser wechselte, verschickte die
  // Schuhgroesse trotzdem mit.
  const isTypeSelector = (field, tf = typeFields) =>
    field.type === 'costume-type-select' ||
    (field.type === 'select' && (field.options || []).some(o => tf?.[o.value]));

  const handleInputChange = (e, fieldName) => {
    setFormData(prev => ({ ...prev, [fieldName]: e.target.value }));
  };

  const handleTypeChange = (e, fieldName) => {
    const newType = e.target.value;
    // typeFields kann leer sein - die Typabhaengigkeit laeuft heute ueber
    // showIf. Ohne diese Absicherung wuerde Object.values(null) werfen.
    const allTypeFieldNames = Object.values(typeFields || {}).flat().map(f => f.name);
    const conditionalFieldNames = formFields.filter(f => f.showIf).map(f => f.name);
    setFormData(prev => {
      const next = { ...prev, [fieldName]: newType };
      [...allTypeFieldNames, ...conditionalFieldNames].forEach(n => delete next[n]);
      return next;
    });
  };

  const handleCheckboxChange = (e, fieldName) => {
    setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }));
  };

  const handleMultiSelectChange = (selectedOptions, fieldName) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: selectedOptions ? selectedOptions.map(o => o.value) : [],
    }));
  };

  const shouldShow = (field) => istSichtbar(field, formData);

  const getSelectedType = () => {
    const typeField = formFields.find(f => isTypeSelector(f));
    return typeField ? (formData[typeField.name] || '') : '';
  };

  const getActiveTypeFields = () => {
    const sel = getSelectedType();
    if (!sel) return [];
    // Auch hier gegen ein leeres typeFields absichern.
    const key = Object.keys(typeFields || {}).find(k => k.toLowerCase() === sel.toLowerCase());
    return key ? typeFields[key] : [];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const invalidFields = [];

    formFields.forEach(field => {
      if (!shouldShow(field)) return;
      if (field.required && (field.type === 'select' || field.type === 'costume-type-select')) {
        if (!formData[field.name]) invalidFields.push(field.label);
      }
      if (field.required && field.type === 'date') {
        if (!formData[field.name]) invalidFields.push(field.label);
      }
    });

    getActiveTypeFields().forEach(field => {
      if (field.required && !formData[field.name]) {
        invalidFields.push(field.label);
      }
    });

    if (invalidFields.length > 0) {
      setErrors(invalidFields);
      return;
    }

    try {
      await api.post('/api/create-apply-haes', formData);
      // Nach dem Antrag ins Profil: dort stehen die eigenen Antraege.
      navigate('/meine-daten', { state: { message: `${cfg.costumeTerm} wurde erfolgreich beantragt!` } });
    } catch {
      setErrors(['Fehler beim Absenden. Bitte erneut versuchen.']);
    }
  };

  const renderTypeField = (field, index) => {
    switch (field.type) {
      case 'select':
        return (
          <div className="mb-3" key={`tf-${index}`}>
            <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
            <select
              className="form-select"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={(e) => handleInputChange(e, field.name)}
              required={field.required}
            >
              <option value="">-- Bitte wählen --</option>
              {(field.options || []).map((opt, i) => (
                <option key={i} value={opt.value}>{opt['frontend-text']}</option>
              ))}
            </select>
          </div>
        );
      case 'number':
        return (
          <div className="mb-3" key={`tf-${index}`}>
            <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
            <input
              type="number"
              className="form-control"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={(e) => handleInputChange(e, field.name)}
              required={field.required}
            />
          </div>
        );
      case 'text':
        return (
          <div className="mb-3" key={`tf-${index}`}>
            <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
            <input
              type="text"
              className="form-control"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={(e) => handleInputChange(e, field.name)}
              required={field.required}
            />
          </div>
        );
      case 'checkbox':
        return (
          <div className="form-check mb-3" key={`tf-${index}`}>
            <input
              type="checkbox"
              className="form-check-input"
              id={field.name}
              checked={formData[field.name] || false}
              onChange={(e) => handleCheckboxChange(e, field.name)}
            />
            <label className="form-check-label" htmlFor={field.name}>{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
          </div>
        );
      default:
        return null;
    }
  };

  const renderFormFields = () => {
    return formFields.map((field, index) => {
      if (!shouldShow(field)) return null;

      switch (field.type) {
        // Nur eine Markierung im Schema: der Server setzt dahinter die
        // typabhaengigen Fragen ein. Angezeigt wird sie nicht.
        case 'type-questions':
          return null;
        case 'costume-type-select':
        case 'select': {
          const isSel = isTypeSelector(field);
          const extra = isSel ? getActiveTypeFields() : [];
          return (
            <React.Fragment key={index}>
              <div className="mb-3">
                <label htmlFor={field.name} className="form-label">
                  {field.label}{field.required && <span className="text-danger ms-1">*</span>}
                </label>
                <select
                  className="form-select"
                  id={field.name}
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={(e) => isSel ? handleTypeChange(e, field.name) : handleInputChange(e, field.name)}
                  required={field.required}
                >
                  <option value="">-- bitte auswählen --</option>
                  {(field.options || []).map((opt, idx) => (
                    <option key={idx} value={opt.value}>{opt['frontend-text']}</option>
                  ))}
                </select>
              </div>
              {extra.length > 0 && (
                <div className="border rounded p-3 mb-3" style={{ background: 'rgba(255,255,255,0.05)' }}>
                  <p className="fw-semibold small text-secondary mb-2">Angaben für: {formData[field.name]}</p>
                  {extra.map((ef, i) => renderTypeField(ef, i))}
                </div>
              )}
            </React.Fragment>
          );
        }

        case 'date':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">
                {field.label}{field.required && <span className="text-danger ms-1">*</span>}
              </label>
              <input
                type={field.dateFormat === 'yyyy' ? 'number' : 'month'}
                className="form-control"
                id={field.name}
                name={field.name}
                min={field.dateFormat === 'yyyy' ? new Date().getFullYear() : undefined}
                max={field.dateFormat === 'yyyy' ? new Date().getFullYear() + 10 : undefined}
                placeholder={field.dateFormat === 'yyyy' ? 'Jahr (z.B. 2027)' : undefined}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
              />
            </div>
          );

        case 'text':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">
                {field.label}{field.required && <span className="text-danger ms-1">*</span>}
              </label>
              <input
                type="text"
                className="form-control"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
              />
            </div>
          );

        case 'checkbox':
          return (
            <div className="mb-3" key={index}>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={field.name}
                  name={field.name}
                  checked={formData[field.name] || false}
                  onChange={(e) => handleCheckboxChange(e, field.name)}
                />
                <label className="form-check-label" htmlFor={field.name}>{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              </div>
            </div>
          );

        case 'number':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">
                {field.label}{field.required && <span className="text-danger ms-1">*</span>}
              </label>
              <input
                type="number"
                className="form-control"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
              />
            </div>
          );

        case 'multiselect':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">
                {field.label}{field.required && <span className="text-danger ms-1">*</span>}
              </label>
              <Select
                isMulti
                options={(field.options || []).map(o => ({ value: o.value, label: o['frontend-text'] }))}
                value={(formData[field.name] || []).map(value => ({
                  value,
                  label: (field.options || []).find(o => o.value === value)?.['frontend-text'] || value,
                }))}
                onChange={(selected) => handleMultiSelectChange(selected, field.name)}
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (base) => ({ ...base, borderRadius: '10px', padding: '10px' }),
                  multiValue: (base) => ({ ...base, backgroundColor: '#6c757d', color: 'white' }),
                  option: (base) => ({ ...base, color: 'black' }),
                }}
              />
            </div>
          );

        default:
          return null;
      }
    });
  };

  if (loading) return <div className="container mt-4"><CustomNavbar /><div className="text-center py-5">Lade Formular…</div></div>;

  return (
    <div className="container mt-4">
      <CustomNavbar />
      <h2 className="mb-4">{formTitle}</h2>

      {errors.length > 0 && (
        <div className="alert alert-danger">
          <strong>Bitte ausfüllen:</strong>
          <ul className="mb-0 mt-1">
            {errors.map((err, idx) => <li key={idx}>{err}</li>)}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {renderFormFields()}
        <button type="submit" className="btn btn-primary mt-2">Absenden</button>
      </form>
      <br /><br />
    </div>
  );
};

export default SrvApplyHaes;
